import script from "./accordeon.vue?vue&type=script&setup=true&lang=js"
export * from "./accordeon.vue?vue&type=script&setup=true&lang=js"

import "./accordeon.vue?vue&type=style&index=0&id=0a0b7f7e&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0a0b7f7e"]])

export default __exports__